import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sales-module',
  templateUrl: './sales-module.component.html',
  styleUrls: ['./sales-module.component.scss'],
})
export class SalesModuleComponent implements OnInit {
  env;

  constructor() {
    this.env = environment;
  }

  ngOnInit() {}
}
